import {
  useQuery,
  keepPreviousData,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { fetchGetQuery, fetchDeleteQuery } from "../api";
import urlBuilder from "../../components/utils/dataGridURLBuilder";
import determineSorting from "../../components/utils/determineSorting";

// Custom hook to fetch paginated project partners with sorting, searching and filtering
export function useGetProjectPartnersPagination(
  pagination,
  sorting,
  search,
  columnFilters,
) {
  const { pageIndex, pageSize } = pagination;

  // Determine sorting field and direction
  const { sortField, sortDirection } = determineSorting(sorting);

  // Filter out inactive filters (empty values)
  const activeFilters = columnFilters.filter((f) =>
    Array.isArray(f.value) ? f.value.length : f.value,
  );

  // Build URL with pagination, sorting, search and active filters
  const url = urlBuilder(
    "Partnerji/seznamPartnerjevPaginationV2",
    pagination,
    sortField,
    sortDirection,
    search,
    activeFilters,
  );

  return useQuery({
    queryKey: [
      "projectPartners",
      pageIndex,
      pageSize,
      sortField,
      sortDirection,
      search,
      columnFilters,
    ],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
    placeholderData: keepPreviousData,
    retry: 0,
  });
}

// DELETE API call to delete project partner by id
export function useDeleteProjectPartner() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (idPartner) => {
      return fetchDeleteQuery(`Partnerji/${idPartner}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["projectPartners"] });
    },
  });
}
